module.exports = __webpack_public_path__ + "media/images/fleche droite-b24143bba24a401474a8bc4c1bbdea0f.svg";